// extracted by mini-css-extract-plugin
module.exports = {"submit":"SubmitBtn_submit__3ty_f"};